<template>
  <div class="card p-shadow-app">
    <h1>Fichas de Colaboradores</h1>
    <div style="height: 65vh">
      <DataTable
        :value="usersList"
        responsiveLayout="scroll"
        ref="dt"
        filterDisplay="row"
        :loading="loading"
        class="p-datatable-sm"
        sortField="name"
        :sortOrder="1"
        :scrollable="true"
        scrollHeight="flex"
        :filters.sync="filters"
      >
        <template #header>
          <div style="text-align: left">
            <MultiSelect name:="columns" inputId:="columns" :filter="true"
            v-model="selectedColumns" :options="columns" :dataKey="'field'"
            optionLabel="header" placeholder="Colunas" style="width: 20em" />
          </div>
        </template>
        <Column
          field="username"
          header="Colaborador"
          sortable
          filterField="username"
        >
          <template #body="slotProps">
            <span
              class="clickable-item"
              v-tooltip="'Ver Ficha Colaborador'"
              @click="viewUser(slotProps.data.id)"
              >{{ slotProps.data.username }}</span
            >
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              class="p-column-filter"
              v-model="filterModel.value"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          v-for="(col, index) of selectedColumns"
          :field="col.field"
          :header="col.header"
          :key="col.field + '_' + index"
          :dataType="
            col.filterType == 'date'
              ? 'date'
              : col.filterType == 'dropdown'
              ? 'boolean'
              : ''
          "
          sortable
        >
          <template #body="slotProps" v-if="col.filterType == 'date'">
            {{ formatDate(slotProps.data[col.field]) }}
          </template>
          <template
            v-if="col.filterType == 'input'"
            #filter="{ filterModel, filterCallback }"
          >
            <InputText
              type="text"
              class="p-column-filter"
              v-model="filterModel.value"
              @input="filterCallback()"
            />
          </template>
          <template
            #filter="{ filterModel, filterCallback }"
            v-else-if="col.filterType == 'dropdown'"
          >
            <Dropdown
              v-model="filterModel.value"
              @input="filterCallback()"
              :options="col.options"
              class="p-column-filter"
              :showClear="true"
            >
            </Dropdown>
          </template>
          <template
            #filter="{ filterModel, filterCallback }"
            v-else-if="col.filterType == 'date'"
          >
            <v-date-picker
              v-model="filterModel.value"
              @input="filterCallback()"
              :masks="{
                input: 'YYYY-MM-DD',
              }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  class="p-column-filter p-inputtext p-component"
                  :value="inputValue"
                  v-on="inputEvents"
                />
              </template>
            </v-date-picker>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import EmployeeService from "../services/employee.service";
import { FilterMatchMode } from "primevue/api/";
import { getOnlyDate } from "../helpers/helpers";

export default {
  name: "EmployeeFiles",
  data() {
    return {
      loading: true,
      usersList: [],
      columns: null,
      selectedColumns: null,
      paginatorInfo: null,
      filters: {
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        username: { value: null, matchMode: FilterMatchMode.CONTAINS },
        department: { value: null, matchMode: FilterMatchMode.CONTAINS },
        area: { value: null, matchMode: FilterMatchMode.CONTAINS },
        office: { value: null, matchMode: FilterMatchMode.CONTAINS },
        startDate: { value: null, matchMode: FilterMatchMode.DATE_IS },
        endContract: { value: null, matchMode: FilterMatchMode.DATE_IS },
        exitDate: { value: null, matchMode: FilterMatchMode.DATE_IS },
        number: { value: null, matchMode: FilterMatchMode.CONTAINS },
        email: { value: null, matchMode: FilterMatchMode.CONTAINS },
        updated: { value: null, matchMode: FilterMatchMode.DATE_IS },
        haveCv: { value: null, matchMode: FilterMatchMode.EQUALS },
        hasCv: { value: null, matchMode: FilterMatchMode.EQUALS },
        hasQualificationsCertificate: {
          value: null,
          matchMode: FilterMatchMode.EQUALS,
        },
        hasCarDeclaration: { value: null, matchMode: FilterMatchMode.EQUALS },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
      },
    };
  },
  created() {
    this.getColumns();
    this.getDefaultColumns();
  },
  async mounted() {
    await this.getEmployees();
  },
  methods: {
    getColumns() {
      this.columns = [
        {
          field: "status",
          header: "Estado",
          filterType: "dropdown",
          options: ["Ativo", "Inativo"],
        },
        { field: "name", header: "Nome", filterType: "input" },
        { field: "department", header: "Departamento", filterType: "input" },
        { field: "area", header: "Área", filterType: "input" },
        { field: "office", header: "Escritório", filterType: "input" },
        {
          field: "startDate",
          header: "Data de Admissão",
          filterType: "date",
        },
        { field: "exitDate", header: "Data de Saída", filterType: "date" },
        {
          field: "number",
          header: "Número de Colaborador",
          filterType: "input",
        },
        { field: "email", header: "Email Profissional", filterType: "input" },
        { field: "updated", header: "Última Actualiação", filterType: "date" },
        {
          field: "haveCv",
          header: "Tem CV",
          filterType: "dropdown",
          options: ["Sim", "Não"],
        },
        {
          field: "hasCv",
          header: "Tem CC",
          filterType: "dropdown",
          options: ["Sim", "Não"],
        },
        {
          field: "hasQualificationsCertificate",
          header: "Tem Certificado Habilitações",
          filterType: "dropdown",
          options: ["Sim", "Não"],
        },
      ];
    },
    getDefaultColumns() {
      this.selectedColumns = [
        {
          field: "status",
          header: "Estado",
          filterType: "dropdown",
          options: ["Ativo", "Inativo"],
        },
        { field: "department", header: "Departamento", filterType: "input" },
        { field: "area", header: "Área", filterType: "input" },
        { field: "office", header: "Escritório", filterType: "input" },
        {
          field: "startDate",
          header: "Data de Admissão",
          filterType: "date",
        },
        {
          field: "endContract",
          header: "Data de Fim de Contrato",
          filterType: "date",
        },
        { field: "exitDate", header: "Data de Saída", filterType: "date" },
      ];
    },
    formatDate(date) {
      if (date == "") {
        return date;
      }
      return getOnlyDate(date);
    },
    async getEmployees() {
      this.loading = true;
      this.usersList = [];
      return EmployeeService.getEmployeeFiles().then((response) => {
        response.forEach((element) => {
          element["status"] = element.active ? "Ativo" : "Inativo";
          element["haveCv"] = element.hasCv ? "Sim" : "Não";
          element["hasCv"] = element.hasQualificationsCertificate
            ? "Sim"
            : "Não";
          element["hasQualificationsCertificate"] =
            element.hasQualificationsCertificate ? "Sim" : "Não";
          element["hasCarDeclaration"] = !element.hasCar
            ? "NA"
            : element.hasCarDeclaration
            ? "Sim"
            : "Não";
          element["exitDate"] =
            element.exitDate != null && element.exitDate != ""
              ? new Date(element.exitDate)
              : "";
          element["endContract"] =
            element.endContract != null && element.endContract != ""
              ? new Date(element.endContract)
              : "";
          element["startDate"] =
            element.startDate != null && element.startDate != ""
              ? new Date(element.startDate)
              : "";
          if (!this.usersList.find((user) => user.id === element.id)) {
            this.usersList.push(element);
          }
        });
        return (this.loading = false);
      });
    },
    viewUser(userId) {
      this.$router.push({
        path: `/employee-info/${userId}`,
      });
    },
  },
};
</script>
<style scoped lang="scss">
td {
  width: 1px;
  white-space: nowrap;
}
.p-datatable-responsive .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.p-column-filter-drop {
  width: 75px !important;
}
.bananas {
  width: 100px !important;
}
</style>
